// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'

export const getAllDataOptionsClient = createAsyncThunk('appUsers/getAllDataOptionsClient', async id => {
  const response = await axios.get('https://apiv3.opentlv.com/api/v3/client/options/all',  { params: { id} })
  return response.data
})

export const getDataOptionsClient = createAsyncThunk('appUsers/getDataOptionsClient', async params => {
  const response = await axios.get('https://apiv3.opentlv.com/api/v3/client/options/data', {params})
  return {
    params,
    data: response.data.data,
    totalPages: response.data.total
  }
})

export const getUser = createAsyncThunk('appUsers/getUser', async id => {
  const response = await axios.get('https://apiv3.opentlv.com/api/v3/users/user', { params: { id} })
  console.log(response.data)
  return response.data
})
export const addOption = createAsyncThunk('appUsers/addOption', async (option, { dispatch, getState }) => {
  option.client_id = getState().sitesClient.params.id
  console.log(getState().sitesClient)


  await axios.post('https://apiv3.opentlv.com/api/v3/client/addoption', option)

  //await dispatch(getAllDataSitesClient(getState().sitesClient.params.id))
  await dispatch(getDataOptionsClient(getState().sitesClient.params))
  return site
})

export const deleteOption = createAsyncThunk('appUsers/deleteOption', async (id, { dispatch, getState }) => {
  console.log("getState()")
  console.log(id)

  await axios.delete('https://apiv3.opentlv.com/api/v3/client/option/delete', {params: {id}})
//  await dispatch(getData(getState().users.params))
    await dispatch(getDataOptionsClient(getState().sitesClient.params))

  return id
})

export const addUser = createAsyncThunk('appUsers/addUser', async (user, { dispatch, getState }) => {
  await axios.post('/apps/users/add-user', user)
  await dispatch(getData(getState().users.params))
  await dispatch(getAllData())
  return user
})

export const deleteUser = createAsyncThunk('appUsers/deleteUser', async (id, { dispatch, getState }) => {
  await axios.delete('/apps/users/delete', { id })
  await dispatch(getData(getState().users.params))
  await dispatch(getAllData())
  return id
})


export const appClientsSlice = createSlice({
  name: 'appUsers',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedUser: null
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getAllDataOptionsClient.fulfilled, (state, action) => {
        state.allData = action.payload
      })
      .addCase(getDataOptionsClient.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })
      .addCase(getUser.fulfilled, (state, action) => {
        state.selectedUser = action.payload
      })
  }
})

export default appClientsSlice.reducer
